import { mutator, mutatorAction } from 'satcheljs';
import {
    panByWheel,
    panDown,
    panLeft,
    panRight,
    panUp,
    resetPanAndZoom,
    zoomByWheel,
    zoomIn,
    zoomOut,
} from '../actions';
import getStore from '../store';

let timeoutId: NodeJS.Timer | null = null;

function showMiniMapWithTimeout(timeout: number) {
    getStore().showMiniMap = true;
    if (timeoutId != null) {
        clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(hideMiniMap, timeout);
}

function showMiniMap() {
    showMiniMapWithTimeout(1000);
}

const hideMiniMap = mutatorAction('hideMiniMap', () => {
    getStore().showMiniMap = false;
    if (timeoutId != null) {
        clearTimeout(timeoutId);
        timeoutId = null;
    }
});

[panByWheel, panDown, panLeft, panRight, panUp, zoomByWheel, zoomIn, zoomOut].forEach(action =>
    mutator(action, showMiniMap)
);

mutator(resetPanAndZoom, ({ initialLoad }) => {
    if (!initialLoad) {
        showMiniMap();
    }
});
